import React from "react";
import "./Discount.css";

function Discounts() {
  return <div>Discounts</div>;
}

export default Discounts;
